export * from "./page.module";

